"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var Luggage = function Luggage(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M1.82035 12.6667C1.48895 12.6667 1.20525 12.5487 0.969251 12.3127C0.73324 12.0767 0.615234 11.793 0.615234 11.4616V4.3334C0.615234 4.00199 0.73324 3.71828 0.969251 3.48228C1.20525 3.24628 1.48895 3.12828 1.82035 3.12828H3.20498V1.87188C3.20498 1.54047 3.32298 1.25677 3.55898 1.02077C3.79498 0.784754 4.07869 0.666748 4.4101 0.666748H5.58957C5.92098 0.666748 6.20468 0.784754 6.44068 1.02077C6.67668 1.25677 6.79468 1.54047 6.79468 1.87188V3.12828H8.17932C8.51072 3.12828 8.79442 3.24628 9.03042 3.48228C9.26643 3.71828 9.38443 4.00199 9.38443 4.3334V11.4616C9.38443 11.793 9.26643 12.0767 9.03042 12.3127C8.79442 12.5487 8.51072 12.6667 8.17932 12.6667V12.7436C8.17932 12.9069 8.12183 13.046 8.00687 13.1609C7.89191 13.2759 7.75281 13.3334 7.58957 13.3334C7.42632 13.3334 7.28722 13.2759 7.17227 13.1609C7.05731 13.046 6.99983 12.9069 6.99983 12.7436V12.6667H2.99983V12.7436C2.99983 12.9069 2.94236 13.046 2.8274 13.1609C2.71245 13.2759 2.57335 13.3334 2.4101 13.3334C2.24686 13.3334 2.10776 13.2759 1.9928 13.1609C1.87783 13.046 1.82035 12.9069 1.82035 12.7436V12.6667ZM1.82035 11.6667H8.17932C8.23915 11.6667 8.2883 11.6475 8.32675 11.609C8.36522 11.5706 8.38445 11.5214 8.38445 11.4616V4.3334C8.38445 4.27357 8.36522 4.22442 8.32675 4.18595C8.2883 4.14748 8.23915 4.12825 8.17932 4.12825H1.82035C1.76052 4.12825 1.71137 4.14748 1.67292 4.18595C1.63445 4.22442 1.61522 4.27357 1.61522 4.3334V11.4616C1.61522 11.5214 1.63445 11.5706 1.67292 11.609C1.71137 11.6475 1.76052 11.6667 1.82035 11.6667ZM3.20498 10.7436H4.20495V5.05135H3.20498V10.7436ZM5.79472 10.7436H6.79468V5.05135H5.79472V10.7436ZM4.20495 3.12828H5.79472V1.87188C5.79472 1.81205 5.77548 1.7629 5.73702 1.72443C5.69855 1.68596 5.6494 1.66673 5.58957 1.66673H4.4101C4.35027 1.66673 4.30112 1.68596 4.26265 1.72443C4.22418 1.7629 4.20495 1.81205 4.20495 1.87188V3.12828Z",
    fill: "#4B4FA6"
  }, colorStyles)));
};

Luggage.propTypes = _inline_svg2.default.propTypes;
Luggage.defaultProps = _inline_svg2.default.defaultProps;
var _default = Luggage;
exports.default = _default;